<template>
  <v-container>
    <v-card>
      <v-row
        justify="center"
        class="mt-2"
      >
        <v-avatar image="lis.jpg" />
      </v-row>
      <v-row justify="center">
        <v-card-title class="font-weight-bold text-primary justify-center">
          Matúš Gál
        </v-card-title>
      </v-row>
      <v-row justify="center">
        <v-card-subtitle>
          <v-icon
            icon="mdi-email"
          />
          matusgal@outlook.com
        </v-card-subtitle>
      </v-row>
      <v-divider/>
      <v-card-subtitle>
        <v-icon icon="mdi-school" />
        Education
      </v-card-subtitle>
      <v-card-text>
        <v-chip>2020-2023</v-chip>
        <ul>
          <li>Master's Degree</li>
          <li>Faculty of Mathematics, Physics and Informatics</li>
          <li>Applied Computer Science</li>
          <li>
            <span class="font-weight-bold">Thesis: </span>
            <ul>
              <li>Symmetries of combinatorial structures</li>
              <li><a href="" @click.prevent="$router.push('/projects/thesis')">More information</a></li>
            </ul>
          </li>
        </ul>
        <v-chip>2017-2020</v-chip>
        <ul>
          <li>Bachelor's Degree</li>
          <li>Faculty of Mathematics, Physics and Informatics</li>
          <li>Applied Computer Science</li>
          <li>
            <span class="font-weight-bold">Thesis: </span>
            <ul>
              <li>Web teaching tool for agile learning new features in C++11, C++14 and C++17</li>
            </ul>
          </li>
        </ul>
      </v-card-text>
      <v-divider/>
      <v-card-subtitle>
        <v-icon icon="mdi-controller-classic"/>
        Hobbies
      </v-card-subtitle>
      <v-card-text class="lis">
        <p>
          I'm a huge motorsport fan, 2 wheels, 4 wheels, combustion engine or battery powered... As long as it goes fast I'm gonna enjoy it.<br>
          I started watching F1 in 2008 and have seen every single race since then live. I'm currently at 300 races and counting.
        </p>

        <p>
          Sometimes, it's good to also go outside and touch grass. I like roller-skating and have been since I was 4 years old. I consider myself
          to be extremely good at skating. The same can't be said about my skills when it comes to other sports.
        </p>

        <p>
          There are some sports I enjoy watching, but would definitely not survive playing them. I love watching the NFL and thanks
          to red being my favourite color I became a fan of the Chiefs, even before they drafted God himself at QB. Travis Kelce is my
          favourite player and the 15 to 87 connection brings me happiness every game.
        </p>

        <p>I also like playing games, mostly single-player, but I also enjoy a nice MP FPS from time to time. I'm primarily a Xbox gamer,
        though I like my Switch as well.</p>

        <p>
          I've played a fair share of games in my life and consider the following games to be the best I've ever played:
          <ol>
            <li>Life is Strange</li>
            <li>Dishonored</li>
            <li>Bioshock Infinite</li>
          </ol>
        </p>

        <p>

        </p>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'AboutComponent',
  data () {
    return {}
  }
}
</script>

<style scoped>
  .lis > * {
    font-family: "dudu", cursive;
  }
</style>
